<template lang="html">
  <div id="intro" class="intro" @click="forceFinishIntro">

    <div class="select-none">

      <!-- <div class="gm-wrapper absolute top-1/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="gm">
          GOSHKA MACUGA
        </div>
      </div> -->

      <div class="credit-wrapper absolute bottom-1/8 left-1/2 transform -translate-x-1/2  w-full pointer-events-auto cursor-pointer hover:text-red-600 group">
        <div class="gm mb-2">
          GOSHKA MACUGA
        </div>
        <div class="credit">
          Digital platform in collaboration with HATO
        </div>

        <div class="block md:hidden bg-red-600 text-white py-2 px-4 text-xl mt-4 ml-4 mr-4 text-center mx-auto group-hover:bg-red-700 ">
          Enter
        </div>
      </div>

      <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full flex justify-center">
        <logo />
      </div>

    </div>

  </div>
</template>

<script>
// import {contents} from '@/common/content.js'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import logo from './logo'

export default {
  // computed: {
  //   contents: ()=> contents
  // },
  components: {
    logo
  },

  data () {
    return {
      isFinished: false,
      timeline: null
    }
  },

  mounted () {
    this.intro_D()
  },

  methods: {

    intro_D () {
      let tl = gsap.timeline({
        repeat: -1,
        repeatDelay: 1,
        onComplete: () => {
          // this.onIntroComplete()
        }
      })
      this.timeline = tl

      const elem_nogo = '.gng-nogo'
      const elem_go = '.gng-go'

      tl.set(elem_nogo, { autoAlpha: 0, delay: 0 })
      tl.set(elem_go, { autoAlpha: 1 })

      tl.set(elem_nogo, { autoAlpha: 1, delay: 1 })
      tl.set(elem_go, { autoAlpha: 0 })

    },

    onIntroComplete () {
      setTimeout(() => {
        this.forceFinishIntro()
      }, 1000)
    },
    forceFinishIntro () {
      if (this.isFinished) return;
      this.isFinished = true
      if (this.timeline) {
        this.timeline.kill()
      }
      this.$store.commit('setStage', { stage: 'ENTERED' })
    }
  }
}
</script>

<style lang="scss" scoped>
.intro {
  @apply w-full h-full relative pointer-events-auto;
  // @apply fixed inset-0 z-50;
}
.gm {
  @apply text-center w-full leading-none;
  // color: white;
  font-size: 8vw;
  letter-spacing: 0.05em;
  @screen md {
    font-size: 2.4vw;
  }
}
.credit {
  @apply text-center w-full leading-tight;
  // color: white;
  font-size: 4vw;
  @screen md {
    font-size: 2vw;
  }
}
.gng {
  @apply text-red-700 text-center w-auto mx-4 flex leading-none;

  font-size: 20vw;
  @screen md {
    font-size: 35vh;
  }
}
</style>
